import type { GameEvent } from '../../core/types';
import { STATUS_HELP } from '../fieldGuide';

export interface CombatFeedback {
  id: number;
  events: GameEvent[];
  title: string;
  summary: string;
}

export function CombatCues({
  feedback,
  targetId,
}: {
  feedback: CombatFeedback | null;
  targetId: string;
}) {
  if (!feedback) return null;
  let damage = 0;
  let blocked = 0;
  let block = 0;
  const other: string[] = [];
  for (const event of feedback.events) {
    if ('targetId' in event && event.targetId === targetId) {
      if (event.type === 'damage') {
        damage += event.amount;
        blocked += event.blocked;
      }
      if (event.type === 'block_gained') block += event.amount;
      if (event.type === 'status_changed') other.push(`+${event.amount} ${STATUS_HELP[event.status].name}`);
    }
    if (event.type === 'enemy_phase_changed' && event.enemyId === targetId) other.push(`Phase ${event.phase}`);
    if (event.type === 'enemy_defeated' && event.enemyId === targetId) other.push('Defeated');
  }
  if (!damage && !blocked && !block && !other.length) return null;

  return (
    <span key={feedback.id} className="combat-cues" aria-hidden="true">
      {damage > 0 ? <strong className="combat-cue combat-cue--damage">−{damage} HP</strong> : null}
      {blocked > 0 ? <strong className="combat-cue combat-cue--block">{blocked} blocked</strong> : null}
      {block > 0 ? <strong className="combat-cue combat-cue--block">+{block} Block</strong> : null}
      {other.map((text, index) => <strong className="combat-cue" key={index}>{text}</strong>)}
    </span>
  );
}
